module.exports = __webpack_public_path__ + "static/TruenoRg-72547ad48a2879ec16c4948688def783.woff";